import clsx from "clsx";
import { Button, Icon } from "@/components/common";

interface CompositePhotoUploaderProps {
  className?: string;
  value?: { url: string } | string | null;
  onClick: () => void;
  onRemove: () => void;
}

export const CompositePhotoUploader = ({ className, value, onClick, onRemove }: CompositePhotoUploaderProps) => {
  const imageUrl = typeof value === "object" ? value?.url : value;

  if (imageUrl) {
    return (
      <div className={clsx("relative w-full group overflow-hidden shadow-sm", className)}>
        <img src={imageUrl} alt="Slot" className="w-full h-full object-cover object-center" />

        <div className="absolute top-3 right-3 z-10">
          <Button
            type="button"
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation();
              onRemove?.();
            }}
            className="flex h-10 w-10 items-center justify-center p-0 hover:bg-gray-50 bg-white"
            title="Remover foto"
          >
            <Icon name="Trash" size="1.25rem" className="text-error" />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      className={clsx(
        "relative flex cursor-pointer flex-col items-center justify-center transition-colors overflow-hidden",
        "bg-white border-2 border-dashed border-gray hover:border-secondary rounded-sm",
        "w-full",
        className,
      )}
    >
      <div className="flex flex-col items-center justify-center gap-2 px-4 text-center pointer-events-none">
        <Icon name="AddPhoto" size="36px" className="text-primary" />

        <span className="text-sm font-medium tracking-wide text-body">Importe uma foto</span>

        <span className="text-xs font-light text-body">PNG ou JPG com até 10MB</span>
      </div>
    </div>
  );
};
